import Vue from 'vue';
import Joins from './Joins.vue';

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(Joins),
}).$mount('#app');
